var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AWS from 'aws-sdk';
import { AwsConfig } from '../../../config/aws';
import Debug from '../../../util/Debug';
/**
 * Provides temporary AWS credentials for services accessed by users who may not be
 * logged in to the app. Can be used for services like CloudWatch. Note that the
 * "unauthenticated role" associated with the Identity Pool needs to have a policy
 * that allows it to access the resources.
 */
export default {
    // /**
    //  * @type {AWS.CognitoIdentityCredentials}
    //  */
    init() {
        const options = {
            IdentityPoolId: AwsConfig.aws_cognito_identity_pool_id,
        };
        const config = {
            region: AwsConfig.aws_cognito_region,
            credentials: null, // ignore credentials that may be set on the global AWS.config
        };
        const creds = new AWS.CognitoIdentityCredentials(options, config);
        AWS.config.credentials = creds;
        return AWS.config.credentials;
    },
    /**
     * @returns {Promise<AWS.CognitoIdentityCredentials>}
     */
    get() {
        return __awaiter(this, void 0, void 0, function* () {
            if (AWS.config.credentials === null) {
                this.init();
            }
            try {
                // getPromise() handles refreshing the credentials if they are not yet
                // loaded or have expired. Before the promise is resolved, they are
                // loaded into the CognitoIdentityCredentials object.
                AWS.config.credentials = this.init();
                return yield Promise.resolve(AWS.config.credentials);
            }
            catch (error) {
                Debug.error('Failed to get credentials', error);
                return Promise.reject(error);
            }
        });
    },
};
//# sourceMappingURL=UnauthenticatedCredentials.js.map